export default __webpack_public_path__ + "static/media/coupon.7f69c48d.png";